var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('img',{staticClass:"tips__left",attrs:{"src":require("../../img/提示.png"),"alt":""}}),_c('div',{staticClass:"tips__right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }